export default "__VITE_ASSET__68ccb515__"